import { render, staticRenderFns } from "./CopyLinkDialog.vue?vue&type=template&id=6de51de8"
import script from "./CopyLinkDialog.vue?vue&type=script&lang=js"
export * from "./CopyLinkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports